import { Typography } from "@material-ui/core"

export default function BoasVindas() {
    return (
        <Typography align="justify" paragraph={true}>
            Bem-vindo ao sistema TCE-Comunica.<br />
            A plataforma TCE-Comunica é uma ferramenta prioritária para comunicação de deliberações e demais atos processuais do TCE-GO aos jurisdicionados.<br />
            É um serviço digital que permite aos jurisdicionados, de forma on-line, o acesso às comunicações processuais do TCE-GO, o envio de respostas/documentos ao TCE-GO, bem como o controle e o acompanhamento por parte dos jurisdicionados dessas comunicações, garantindo maior transparência das informações.<br />
            A <a href="https://gnoi.tce.go.gov.br/atoNormativo/Publicado?id=23748">Resolução Normativa 10/2024</a> institui o TCE-Comunica e dispõe sobre procedimentos de comunicação processual no âmbito do TCE-GO.<br />
            Acesse o <a href="https://wiki.tce.go.gov.br/doku.php/pres:gerti:manuais:tce_comunica">manual do sistema</a> caso precise de ajuda para utilizar o sistema.
        </Typography>
    )
}